import { render, staticRenderFns } from "./bwcUsedCoupon.vue?vue&type=template&id=1213e120&scoped=true"
import script from "./bwcUsedCoupon.vue?vue&type=script&lang=js"
export * from "./bwcUsedCoupon.vue?vue&type=script&lang=js"
import style0 from "./bwcUsedCoupon.vue?vue&type=style&index=0&id=1213e120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213e120",
  null
  
)

export default component.exports